import { BotevoDesignTokens } from "../../assets/themes/botevoPreset";

interface ISeverity {
  status: Severity;
  color: string;
  iconUrl: string;
}

export type Severity = "OK" | "MAJOR" | "MINOR" | "CRITICAL" | "UNKNOWN";

export const SEVERITY: Record<Severity, ISeverity> = {
  OK: {
    status: "OK",
    color: BotevoDesignTokens.primitive?.green?.["400"] ?? "#59c92e",
    iconUrl: "assets/icons/map_marker_ok.svg",
  },
  MINOR: {
    status: "MINOR",
    color: BotevoDesignTokens.primitive?.blue?.["400"] ?? "#0077ff",
    iconUrl: "assets/icons/map_marker_minor.svg",
  },
  MAJOR: {
    status: "MAJOR",
    color: BotevoDesignTokens.primitive?.yellow?.["400"] ?? "#eab62f",
    iconUrl: "assets/icons/map_marker_warning.svg",
  },
  CRITICAL: {
    status: "CRITICAL",
    color: BotevoDesignTokens.primitive?.red?.["400"] ?? "#ff6347",
    iconUrl: "assets/icons/map_marker_critical.svg",
  },
  UNKNOWN: {
    status: "UNKNOWN",
    color: BotevoDesignTokens.primitive?.grayTransparent?.["600"] ?? "#ebebeba9",
    iconUrl: "assets/icons/map_marker_non_iot.svg",
  },
};
